export default function getAltAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}


//////////////////
// WEBPACK FOOTER
// ./~/@popperjs/core/lib/utils/getAltAxis.js
// module id = 1324
// module chunks = 0